import { useState } from 'react';
import DataTable from '@/components/features/data-table/DataTable';
import { useNavigate } from 'react-router-dom';
import { OnboardingStatusHeader } from '@/components/features/onboarding-status/OnboardingStatusHeader';

const StoresMissingDataTable = ({ startDate, endDate, config }) => {
  const navigate = useNavigate();
  const [totalStoresCount, setTotalStoresCount] = useState(0);

  const columns = [
    {
      columnKey: 'erpId',
      header: 'ERP ID',
      cellData: ctx => {
        const erpId = ctx.row.original.erpId;
        return erpId ? (
          <span
            style={{
              cursor: 'pointer',
              color: '#66A5E7',
              textDecoration: 'none'
            }}
            onClick={e => {
              e.stopPropagation();
              navigate(`/profile/store/${erpId}`);
            }}>
            {erpId}
          </span>
        ) : (
          '-'
        );
      }
    },
    {
      columnKey: 'error',
      header: 'Error',
      cellData: ctx => config?.title || ''
    }
  ];

  const calculateTotalStoresCount = () => {
    return totalStoresCount > 0
      ? totalStoresCount + (totalStoresCount > 1 ? ' Stores' : ' Store')
      : null;
  };

  const fetchFunction = (apiPage, apiPageSize, filtersWithSort) => {
    return config?.fetchFunction(
      apiPage,
      apiPageSize,
      filtersWithSort,
      startDate,
      endDate
    );
  };

  return (
    <DataTable
      tableHeader={<OnboardingStatusHeader title={config?.title} />}
      subHeader={calculateTotalStoresCount()}
      columns={columns}
      isDark={true}
      showColumnFilters={true}
      onSettingsClicked={() => alert('Settings clicked')}
      selection='multiple'
      idField='storeId'
      pageSize={10}
      enableSorting={true}
      fetchFunction={fetchFunction}
      setTotalStoresCount={setTotalStoresCount}
      downloadFileName={config?.downloadFileName}
    />
  );
};

export default StoresMissingDataTable;
